// Clinical ECG display constants.
//
// Standard ECG paper conventions:
//   - Paper speed:     25 mm/s   (so 1 small 1mm box = 0.04 s, 1 large 5mm box = 0.2 s)
//   - Amplitude gain:  10 mm/mV  (so 1 small 1mm box = 0.1 mV, 1 large 5mm box = 0.5 mV)
//   - Grid:            minor lines every 1 mm, major (bold) lines every 5 mm
//
// We render in "mm space" and convert to pixels with PX_PER_MM so the grid and
// the trace stay perfectly aligned at every zoom level.

export const PX_PER_MM = 4; // base on-screen size of 1 mm at 100% zoom
export const MINOR_MM = 1; // minor grid spacing (mm)
export const MAJOR_MM = 5; // major grid spacing (mm)

// Selectable paper speeds (mm/s) — 25 is the clinical default.
export const PAPER_SPEEDS = [12.5, 25, 50] as const;
export const DEFAULT_PAPER_SPEED = 25;

// Selectable amplitude gains (mm/mV) — 10 is the clinical default.
export const AMPLITUDE_GAINS = [5, 10, 20] as const;
export const DEFAULT_AMPLITUDE_GAIN = 10;

// Selectable zoom multipliers applied on top of PX_PER_MM.
export const ZOOM_LEVELS = [0.75, 1, 1.5, 2] as const;
export const DEFAULT_ZOOM = 1;

// Height of each lead row in mm. 30 mm = 6 large boxes, so rows align to the
// major grid and the baseline sits 15 mm (±1.5 mV at standard gain) from the
// edges — enough headroom for normal QRS complexes.
export const ROW_HEIGHT_MM = 30;

// ECG grid colours (clinical pink/red — intentionally not portal tokens so the
// chart reads like real ECG paper for clinicians).
export const ECG_COLORS = {
  paper: "#FFFAFA",
  minorLine: "#F7C9C9",
  majorLine: "#E79A9A",
  trace: "#1A1A1A",
};
